'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isInteger(value) {
    return Number.isInteger(value);
}

exports.isInteger = isInteger;
